import React from "react";
import TeamCard from "./card";
import bgimg from "./../../assets/image/bubble.png";
import avaimg2 from "./../../assets/image/ezgif-4-91bc1dfd26-unscreen.gif";

const data = [
  {
    id: 1,
    avatar:
      "https://cdn.dribbble.com/users/81997/avatars/small/6606012741df3f8cdbb2dfdf7bb52933.jpg?1603031532",
    images: [
      "https://cdn.dribbble.com/userupload/2347435/file/original-f9d0f50e1e91bf65eacb0defe52f3a0a.png?filters:format(webp)?filters%3Aformat%28webp%29=&compress=1&resize=1600x1200",
      "https://cdn.dribbble.com/userupload/2347292/file/original-4476409be0c183dd3524d451ac74af93.png?filters:format(webp)?filters%3Aformat%28webp%29=&compress=1&resize=1600x1200",
    ],
    fullName: "Sina Emammi",
    specialty: "Supporter But Destroyer",
  },
  {
    id: 2,
    avatar:
      "https://cdn.dribbble.com/users/3604170/avatars/small/3f522280bcdaa1cae6f73fa0aa27c4ba.png?1595540196",
    images: [
      "https://cdn.dribbble.com/users/1327459/screenshots/17688016/media/58a5d894d7a517833a5ef4b89688eda9.png?compress=1&resize=1200x900&vertical=top",
      "https://cdn.dribbble.com/users/3604170/screenshots/17686084/media/731c9c5179b4e94076f4c3cb37f0965a.jpg?compress=1&resize=1200x900&vertical=top",
    ],
    fullName: "Saharnaz Choupany",
    specialty: "BackEnd Developer",
  },
  {
    id: 3,
    avatar:
      "https://cdn.dribbble.com/users/3047488/avatars/normal/361f99389bc5e50bdc8cd78bb8a17951.jpg?1588318835",
    images: [
      "https://cdn.dribbble.com/users/3047488/screenshots/15401391/media/aca070433347d7cfbeee77cdac70689b.png?compress=1&resize=1200x900&vertical=top",
      "https://cdn.dribbble.com/users/3047488/screenshots/15253058/media/0ea4302e742221b11ce6bbb3a514ba9b.png?compress=1&resize=1200x900&vertical=top",
    ],
    fullName: "Vahid Abbasiy",
    specialty: "UI/UX Designer",
  },
  {
    id: 4,
    avatar:
      "https://cdn.dribbble.com/users/1619633/avatars/normal/d2321d1d31eaf8a450642a04a428fa92.jpg?1623076528",
    images: [
      "https://cdn.dribbble.com/users/1619633/screenshots/17350060/media/5b0722a464dce46aa58ffa5166b33bd9.png?compress=1&resize=1200x900&vertical=top",
      "https://cdn.dribbble.com/users/1619633/screenshots/17341355/media/eae8951fe58f8254deb9b47bc521aa5f.png?compress=1&resize=1200x900&vertical=top",
    ],
    fullName: "Afshin T2Y ✪",
    specialty: "UI/UX Designer",
  },
];

const Index = () => {
  const filterData = data.slice(0, 3);
  return (
    <>
      <div class="relative lg:container mx-auto px-4 lg:px-24 grid grid-cols-1 lg:grid-cols-2 gap-4 text-gray-900 py-24 md:py-44">
        {/* Left Section */}
        <div className="absolute z-0 left-0">
          <div className="dark:absolute dark:top-40 dark:left-0 dark:h-96 dark:w-96 dark:bg-gradient-to-l dark:from-slate-800"></div>
          <img src={bgimg} alt="" className="h-96 mt-40 dark:opacity-5" />
        </div>
        <div className="space-y-2 z-10">
          <img src={avaimg2} alt="" className="h-52 -mt-7" />
          <h1 class="text-4xl lg:text-7xl font-black text-slate-900 dark:text-white">
            ADONIX
            <span class="text-white dark:text-slate-800 outline-title">
              {" "}
              TEAM
            </span>
          </h1>
          <p className="text-slate-800 dark:text-slate-400">
            Our teams will execute your projects in the fastest possible time
            and with the highest quality with the most up-to-date methods.
          </p>
          <button className="py-4 px-8 w-full sm:w-auto bg-slate-900 text-white transition hover:bg-lime-400 hover:text-slate-900 ease-in-out duration-300 rounded-xl font-CabinetGrotesk">
            See All
          </button>
        </div>
        {/* Rignt Section */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 z-10 sm:-translate-y-16">
          {filterData.map((item, index) => (
            <div
              key={item.id}
              className={index % 2 === 0 ? "sm:translate-y-24" : ""}
            >
              <TeamCard
                name={item.fullName}
                specialty={item.specialty}
                avatar={item.avatar}
                images={item.images}
              />
            </div>
          ))}
          <div className="flex flex-col justify-between w-full rounded-xl sm:transform p-4 bg-white border border-slate-100 dark:bg-slate-800 dark:border-slate-700">
            <div>
              <p className="font-black text-2xl text-slate-900 dark:text-white mb-4">
                You are the next person!
              </p>
              <p className="text-base text-slate-600 dark:text-slate-400 mb-4">
                Your place in our team is empty If you have a specialized field,
                join us now.
              </p>
            </div>
            <button className="flex text-center justify-center py-4 px-8 w-full sm:w-auto bg-lime-400 text-slate-900 transition ease-in-out duration-300 hover:bg-lime-500 rounded-xl font-CabinetGrotesk">
              <svg
                className="mr-1"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M15.9225 1.50001L15.9869 1.50001L18.5986 1.50001L18.6193 1.50001C19.0218 1.5 19.354 1.5 19.6246 1.52211C19.9056 1.54507 20.164 1.59435 20.4066 1.718C20.783 1.90974 21.0889 2.21571 21.2807 2.59203C21.4043 2.8347 21.4536 3.09305 21.4766 3.3741C21.4987 3.64468 21.4987 3.97684 21.4986 4.37929V4.37935V4.40001L21.4987 7.01179L21.4987 7.07614C21.4988 7.74843 21.4988 8.17096 21.4019 8.57443C21.3162 8.93156 21.1748 9.27296 20.9829 9.58612C20.7661 9.9399 20.4673 10.2386 19.9918 10.7139L19.9463 10.7595L16.6518 14.0539C17.0159 14.5636 17.3072 14.9756 17.5238 15.3329C17.7651 15.7308 17.9332 16.0913 18.0125 16.4851C18.1429 17.1326 18.0875 17.8037 17.8526 18.421C17.7097 18.7965 17.4847 19.1246 17.1815 19.4775C16.8851 19.8223 16.4908 20.2166 15.992 20.7154L15.9778 20.7297L15.3539 21.3535C15.25 21.4575 15.1056 21.5104 14.9591 21.4983C14.8126 21.4861 14.6789 21.4102 14.5935 21.2906L12.431 18.2632C12.3275 18.3607 12.2299 18.449 12.1369 18.528C11.8581 18.7647 11.5873 18.9465 11.2712 19.0492C10.7691 19.2124 10.2282 19.2124 9.72611 19.0492C9.41001 18.9465 9.13918 18.7647 8.86044 18.528C8.58973 18.2982 8.28068 17.9892 7.89753 17.606L7.89752 17.606L7.89747 17.6059L7.88236 17.5908L5.40784 15.1163L5.39271 15.1012L5.39267 15.1011C5.00951 14.718 4.70046 14.4089 4.47064 14.1382C4.23401 13.8595 4.05215 13.5887 3.94944 13.2726C3.78629 12.7704 3.78629 12.2296 3.94944 11.7275C4.05215 11.4114 4.234 11.1405 4.47064 10.8618C4.54951 10.7689 4.63772 10.6715 4.73505 10.5681L1.70938 8.40681C1.58978 8.32138 1.51383 8.18765 1.5017 8.04118C1.48958 7.8947 1.54252 7.75031 1.64645 7.64639L2.27055 7.02231L2.2848 7.00805C2.78359 6.50928 3.17784 6.11503 3.52267 5.81871C3.87554 5.51547 4.20356 5.29052 4.57902 5.14764C5.19626 4.91275 5.86737 4.85728 6.51479 4.98766C6.90862 5.06697 7.26912 5.23502 7.66698 5.47621C8.02389 5.69258 8.43544 5.98351 8.94451 6.34705L12.2392 3.05235L12.2847 3.00684C12.76 2.53139 13.0588 2.23257 13.4125 2.01577C13.7257 1.82387 14.0671 1.68246 14.4242 1.59672C14.8277 1.49985 15.2502 1.49991 15.9225 1.50001ZM15.6451 13.6465L19.2392 10.0523C19.7749 9.51666 19.9828 9.30417 20.1303 9.06362C20.2673 8.83994 20.3683 8.59607 20.4296 8.34098C20.4954 8.06665 20.4987 7.76936 20.4987 7.01179L20.4986 4.40001C20.4986 3.97172 20.4983 3.68057 20.4799 3.45553C20.462 3.23632 20.4295 3.12422 20.3897 3.04602C20.2938 2.85786 20.1408 2.70488 19.9526 2.609C19.8744 2.56916 19.7623 2.5367 19.5431 2.51879C19.3181 2.5004 19.0269 2.50001 18.5986 2.50001L15.9869 2.50001C15.2293 2.50001 14.932 2.50323 14.6577 2.56909C14.4026 2.63033 14.1587 2.73134 13.935 2.86841C13.6945 3.01582 13.482 3.22377 12.9463 3.75945L8.38832 8.31745L5.85365 10.8535C5.84814 10.859 5.84253 10.8644 5.83683 10.8696C5.57868 11.1295 5.38338 11.3318 5.23298 11.509C5.0365 11.7404 4.94616 11.8959 4.90049 12.0365C4.80261 12.3378 4.80261 12.6623 4.90049 12.9635C4.94616 13.1041 5.0365 13.2596 5.23298 13.491C5.43325 13.727 5.7131 14.0074 6.11495 14.4092L6.99902 15.2933L8.64579 13.6465C8.84106 13.4512 9.15764 13.4512 9.3529 13.6465C9.54816 13.8418 9.54816 14.1584 9.3529 14.3536L7.70613 16.0004L8.58946 16.8837C8.99131 17.2856 9.27171 17.5654 9.50762 17.7657C9.73906 17.9622 9.89458 18.0525 10.0351 18.0982C10.3364 18.1961 10.6609 18.1961 10.9622 18.0982C11.1027 18.0525 11.2582 17.9622 11.4897 17.7657C11.7256 17.5654 12.006 17.2856 12.4078 16.8837L15.6451 13.6465ZM5.44515 9.84641L7.68093 7.61063L8.22738 7.06388C7.78137 6.74617 7.4408 6.5085 7.14858 6.33135C6.80127 6.12081 6.5531 6.01545 6.31738 5.96798C5.85494 5.87486 5.37558 5.91447 4.93469 6.08225C4.70996 6.16777 4.48245 6.31244 4.17442 6.57714C3.86162 6.84594 3.49382 7.21327 2.97765 7.72942L2.77091 7.93616L5.44515 9.84641ZM15.0641 20.2291L13.1533 17.5539L15.935 14.771C16.2533 15.2178 16.4914 15.5588 16.6688 15.8513C16.8793 16.1987 16.9847 16.4468 17.0322 16.6826C17.1254 17.1451 17.0858 17.6244 16.918 18.0654C16.8325 18.2901 16.6878 18.5176 16.423 18.8257C16.1542 19.1385 15.7869 19.5063 15.2706 20.0226L15.0641 20.2291ZM12.502 8.99955C12.502 8.17112 13.1735 7.49955 14.002 7.49955C14.8304 7.49955 15.502 8.17112 15.502 8.99955C15.502 9.82797 14.8304 10.4995 14.002 10.4995C13.1735 10.4995 12.502 9.82798 12.502 8.99955ZM14.002 6.49955C12.6212 6.49955 11.502 7.61884 11.502 8.99955C11.502 10.3803 12.6212 11.4995 14.002 11.4995C15.3827 11.4995 16.502 10.3803 16.502 8.99955C16.502 7.61883 15.3827 6.49955 14.002 6.49955Z"
                  fill="#111827"
                />
              </svg>
              <span>Let's go</span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Index;
